import { COLORS } from 'consts/colors'
import styled from 'styled-components'

export const Line = styled.div<{
  $left: number
  $width: number
  $top: number
  $height: number
}>`
  position: absolute;
  left: ${({ $left }) => $left}px;
  width: ${({ $width }) => $width}px;
  top: ${({ $top }) => $top}px;
  height: ${({ $height }) => $height}px;
  background-color: ${COLORS.primaryDark};
  border: 1px solid ${COLORS.borderColor};
  border-radius: 4px;
  pointer-events: none;
  opacity: 0.2;
`
